function InputGeral({ placeholder, value, onChange, disabled = false, type }) {
  return (
    <input
      style={{
        color: "var(--cor-preto)",
        backgroundColor: "var(--cor-branco)",
        border: "1px solid var(--cor-cinzaMargin)",
        marginTop: 5,
        fontSize: 20,
        margin: "none",
        borderRadius: 10,
        width: "97%",
        height: 40,
        fontFamily: "Roboto",
        padding: 2,
        paddingLeft: 10
      }}
      disabled={disabled}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      type={type}
    />
  );
}
export default InputGeral;
